var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupUserLimit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 489.77,
    height: 383.362,
    viewBox: "0 0 489.77 383.362",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2178",
    "data-name": "Ret\\xE2ngulo 2178",
    width: 441.876,
    height: 378.694,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_User_Limit",
    "data-name": "Group User Limit",
    transform: "translate(0 0.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7141",
    "data-name": "Grupo 7141",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7133",
    "data-name": "Grupo 7133",
    transform: "translate(96.068 24.946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8510",
    "data-name": "Caminho 8510",
    d: "M786.1,593.631q-.61,1.151-1.266,2.287l-.035.061-15.063,26.089-1.362,2.356-15.651,27.11-1.3,2.253-10.661,18.463a73.627,73.627,0,0,1-22.348,24.067c-.872.6-1.758,1.171-2.655,1.727a73.675,73.675,0,0,1-38.846,11.068H588.774a73.718,73.718,0,0,1-49.285-18.893q-1.1-.99-2.176-2.038a73.579,73.579,0,0,1-12.388-15.931l-11.793-20.428-1.374-2.383-18.091-31.328-1.589-2.757-11.222-19.438a73.067,73.067,0,0,1-4.083-8.217q-.7-1.646-1.3-3.312a73.693,73.693,0,0,1,5.384-62.194l5.473-9.48,1.454-2.517,14.944-25.886,1.358-2.353,17.155-29.712,1.343-2.335,2.341-4.053a73.734,73.734,0,0,1,58.887-36.691q2.234-.155,4.5-.165c.154,0,.31,0,.464,0h88.138a73.71,73.71,0,0,1,46.968,16.9q1.149.95,2.267,1.953a73.61,73.61,0,0,1,14.615,18.011l17.22,29.831,1.32,2.283,16.316,28.262,1.485,2.568,7.73,13.39A73.6,73.6,0,0,1,790.9,535.67q.443,1.318.833,2.656a73.711,73.711,0,0,1-5.639,55.305Z",
    transform: "translate(-470.978 -409)",
    fill: "#ebedfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8511",
    "data-name": "Caminho 8511",
    d: "M887.72,582.5a292.028,292.028,0,0,1-31.938,9.705,265.371,265.371,0,0,1-62.391,7.522,257.3,257.3,0,0,1-44.644-3.9,269.826,269.826,0,0,1-99.088-39.053L651,554.438a267.122,267.122,0,0,0,98.213,38.739c45.761,8.063,91.712,3.7,137.185-12.96Z",
    transform: "translate(-599.395 -513.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8512",
    "data-name": "Caminho 8512",
    d: "M856.908,1197.8l-1.3,2.253a270.462,270.462,0,0,0-100.83-27.574c-56.388-4.1-103.981,10.247-137.462,25.609l-1.374-2.383a296.1,296.1,0,0,1,29.385-11.694A278.325,278.325,0,0,1,754.972,1169.8a271.838,271.838,0,0,1,85.007,20.279Q848.528,1193.64,856.908,1197.8Z",
    transform: "translate(-575.165 -955.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8513",
    "data-name": "Caminho 8513",
    d: "M887.892,1373.548c-.872.6-1.758,1.17-2.655,1.726a231.629,231.629,0,0,0-43.505-15.063c-52.938-12.561-99.552-4.172-132.76,7.242q-1.111-1-2.18-2.042a257.022,257.022,0,0,1,28.619-8.155c36.1-8.045,72.085-7.933,106.943.338A234.025,234.025,0,0,1,887.892,1373.548Z",
    transform: "translate(-640.455 -1086.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8514",
    "data-name": "Caminho 8514",
    d: "M1014.422,427.861a172.591,172.591,0,0,1-40.826,8.885q-6.937.621-13.827.622a149.305,149.305,0,0,1-38.422-4.993,154.92,154.92,0,0,1-49.261-23.2q2.234-.155,4.5-.165a151.7,151.7,0,0,0,45.454,20.766c34.045,9.049,65.315,4.463,90.111-3.877Q1013.306,426.859,1014.422,427.861Z",
    transform: "translate(-759.252 -409.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8515",
    "data-name": "Caminho 8515",
    d: "M1188.715,839.753c17.922,10.638,40.508,21.035,66.643,30.744L1254,872.854c-26.109-9.721-48.694-20.133-66.651-30.79-28.542-16.936-42.53-32.882-40.462-46.107.963-6.144,5.473-11.858,13.4-16.986,7.326-4.732,17.6-8.992,30.53-12.653,18.943-5.361,42.955-9.322,70.427-11.652l1.485,2.567c-66.681,5.492-110.232,20.252-113.188,39.138C1147.678,808.249,1161.593,823.658,1188.715,839.753Z",
    transform: "translate(-956.603 -657.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8516",
    "data-name": "Caminho 8516",
    d: "M1478.393,901.926a102.686,102.686,0,0,0,20.988,15.324q-.609,1.152-1.266,2.287l-.035.061c-24.78-14-37.518-31.639-34.076-42.88,2.978-9.725,18.79-16.218,40.182-17.431q.444,1.318.833,2.655c-20.417,1.044-35.791,6.9-38.443,15.558C1464.665,883.743,1469.082,892.873,1478.393,901.926Z",
    transform: "translate(-1184.262 -732.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8517",
    "data-name": "Caminho 8517",
    d: "M679.443,754.677c-1.289,8.65-9.192,17.4-22.842,25.31-12.5,7.238-29.029,13.432-47.807,17.911a240.077,240.077,0,0,1-54.707,6.731q-3.3,0-6.513-.115l-1.589-2.757q3.886.173,7.871.169a240.148,240.148,0,0,0,54.316-6.643c18.26-4.356,34.981-10.612,47.082-17.623,12.922-7.483,20.367-15.57,21.534-23.384,1.862-12.462-11.6-28.039-38.934-45.052-20.774-12.933-48.51-26.062-81.219-38.511l1.358-2.353c32.7,12.462,60.449,25.617,81.28,38.585,13.659,8.5,24.021,16.752,30.8,24.52C677.344,739.8,680.5,747.611,679.443,754.677Z",
    transform: "translate(-524.885 -595.401)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8518",
    "data-name": "Caminho 8518",
    d: "M533.032,838.686c-6.5,6.682-16.472,10.45-27.54,10.45q-.765,0-1.543-.023a55.385,55.385,0,0,1-15.7-2.867q-.7-1.646-1.3-3.312a53.284,53.284,0,0,0,17.082,3.492c10.926.342,20.793-3.162,27.072-9.613,11.08-11.387,10.738-30.972,4.007-43.325-6.478-11.889-20.083-19.484-37.3-22.229l1.454-2.517c.261.042.522.092.779.138,17.731,3.285,31.021,11.567,37.426,23.326C544.668,805.413,544.975,826.409,533.032,838.686Z",
    transform: "translate(-482.458 -667.545)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7137",
    "data-name": "Grupo 7137",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7136",
    "data-name": "Grupo 7136",
    transform: "translate(142.19 105.7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7135",
    "data-name": "Grupo 7135",
    transform: "translate(0 19.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8519",
    "data-name": "Caminho 8519",
    d: "M1401.118,1902.218,1387.9,1932.3a4.464,4.464,0,0,0,1.526,5.452h0a4.464,4.464,0,0,0,6.217-1.1l26.281-37.517-12.907-7.918Z",
    transform: "translate(-1175.817 -1574.536)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8520",
    "data-name": "Caminho 8520",
    d: "M0,0H13.543V14.221a3.493,3.493,0,0,1-3.493,3.493H3.494A3.493,3.493,0,0,1,0,14.221V0Z",
    transform: "matrix(0.574, -0.819, 0.819, 0.574, 216.234, 321.922)",
    fill: "#fb855f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8521",
    "data-name": "Caminho 8521",
    d: "M696.234,848.053s10.915,24.324,16.039,45.783a83.809,83.809,0,0,1,2.609,17.7c.084,8.023-2.128,13.688-8.307,14.311a8.3,8.3,0,0,1-2.808-.189s-.009-.009-.014-.005a9.431,9.431,0,0,1-2.27-.88.285.285,0,0,1-.053-.028,14.926,14.926,0,0,1-3.918-3.263c-2.821-3.175-5.29-7.861-7.426-13.316-8.475-21.611-11.832-55.283-11.832-55.283C685.04,844.758,696.234,848.053,696.234,848.053Z",
    transform: "translate(-666.068 -824.345)",
    fill: "#ffaa40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8522",
    "data-name": "Caminho 8522",
    d: "M812.467,939.526s-24.751,24.226-45.957,33.884c-7.083,3.229-13.764,4.832-19,3.371,0,0-.009-.009-.013-.005a12.636,12.636,0,0,1-2.27-.88.31.31,0,0,1-.053-.028,11.847,11.847,0,0,1-3.918-3.263,13.109,13.109,0,0,1-.924-1.307c-2.486-3.98-.97-8.815,2.877-13.913a73.809,73.809,0,0,1,12.806-12.426c17.277-13.694,41.593-26.009,41.593-26.009C808.29,915.925,820.293,929.749,812.467,939.526Z",
    transform: "translate(-709.809 -875.468)",
    fill: "#ffaa40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8523",
    "data-name": "Caminho 8523",
    d: "M1256.493,1016.983a.083.083,0,0,0-.036.013c-.605.18-1.2.338-1.773.45a10.69,10.69,0,0,1-6.155-.354,8.563,8.563,0,0,1-1.866-1.045c-3.932-2.9-4.157-7.245-2.032-12.3,1.908-4.568,5.727-9.713,10.451-14.92,15.331-16.9,40.175-34.4,40.175-34.4s11.3,2.875,12.993,13.331c0,0-21.245,28.844-39.969,42.7A41.691,41.691,0,0,1,1256.493,1016.983Z",
    transform: "translate(-1072.16 -901.271)",
    fill: "#ffaa40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8524",
    "data-name": "Caminho 8524",
    d: "M1138.5,1002.459a.081.081,0,0,0-.037.013,12.031,12.031,0,0,1-1.772.45,14.673,14.673,0,0,1-6.155-.354c-4.085-1.041-8.442-3.529-12.823-6.868-18.454-14.073-37.288-43.287-37.288-43.287-5.705-11.151,8.53-22,18.392-16.9,0,0,24.735,20.334,38.272,38.782,4.578,6.238,7.877,12.262,8.5,17.212a8.941,8.941,0,0,1-2.158,7.683A12.359,12.359,0,0,1,1138.5,1002.459Z",
    transform: "translate(-954.166 -886.747)",
    fill: "#ffaa40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8525",
    "data-name": "Caminho 8525",
    d: "M883.83,1390.889h0a18.707,18.707,0,0,1-18.686-17.656c-2.319-41.962-3.339-84.947-2.356-116.475h40.955c-1.294,35.914-1.612,77.7-1.2,115.207a18.715,18.715,0,0,1-18.714,18.924Z",
    transform: "translate(-798.423 -1118.553)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8526",
    "data-name": "Caminho 8526",
    d: "M890.848,1605.318h0a18.642,18.642,0,0,0-18.613,19.753c2.163,36.166,5.245,89.023,6.85,112.211h31.691c-1.258-26.419-.876-80.583-1.283-113.554A18.642,18.642,0,0,0,890.848,1605.318Z",
    transform: "translate(-805.457 -1369.062)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8527",
    "data-name": "Caminho 8527",
    d: "M1047.5,1341.759h0a18.707,18.707,0,0,1-22.063-13.195c-11.343-40.467-21.639-82.213-27.5-113.207l39.985-8.861c6.507,35.342,15.237,76.212,23.755,112.737a18.714,18.714,0,0,1-14.176,22.525Z",
    transform: "translate(-895.823 -1082.431)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8528",
    "data-name": "Caminho 8528",
    d: "M1095.411,1558.4h0a18.643,18.643,0,0,0-.46,27.137c25.952,25.281,63.824,62.281,80.625,78.344l23.429-21.34c-18.72-18.684-54.911-58.985-77.413-83.087a18.641,18.641,0,0,0-26.181-1.054Z",
    transform: "translate(-961.497 -1331.844)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8529",
    "data-name": "Caminho 8529",
    d: "M863.742,1003.77s1.048-83.12,23.968-94.953c13.14-6.783,40.334-4.941,54.2,4.431,14,9.458,4.111,90.522,4.111,90.522Z",
    transform: "translate(-799.377 -865.566)",
    fill: "#ffaa40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8530",
    "data-name": "Caminho 8530",
    d: "M1421.747,916.695s.072-4.665,2.239-7.8,4.016-4.976,4.385-9.426,5.192-3.265,4.7.58-2.163,9.822,2.681,8.891,10.861-12.026,14.978-5.327c0,0,3.919-4.276,5.614-2.339s-1.833,5.837-1.833,5.837,6.857,1.135-3.885,9.424c0,0,2.562,2.072.694,3.95-2.988,3-11.834,6.435-19.364,7.046C1419.718,928.523,1421.747,916.695,1421.747,916.695Z",
    transform: "translate(-1200.321 -859.721)",
    fill: "#fd8b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8531",
    "data-name": "Caminho 8531",
    d: "M1481.24,930.662l-.272-.467c10.427-6.062,12.158-9.122,12.174-9.152l.478.253C1493.554,921.422,1491.864,924.485,1481.24,930.662Z",
    transform: "translate(-1242.973 -877.277)",
    fill: "#e56542"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8532",
    "data-name": "Caminho 8532",
    d: "M1491.852,942.947l-.23-.489c5.818-2.737,12.944-9.177,13.015-9.241l.364.4C1504.929,933.681,1497.744,940.175,1491.852,942.947Z",
    transform: "translate(-1250.63 -886.026)",
    fill: "#e56542"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8533",
    "data-name": "Caminho 8533",
    d: "M1496.063,970.965l-.225-.491c3.538-1.625,7.958-3.88,8-3.9l.246.482C1504.042,967.075,1499.611,969.336,1496.063,970.965Z",
    transform: "translate(-1253.66 -909.998)",
    fill: "#e56542"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7134",
    "data-name": "Grupo 7134"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8534",
    "data-name": "Caminho 8534",
    d: "M664.448,790.981a17.038,17.038,0,0,0-.193-7.989c-1.208-3.611-2.433-5.913-1.733-10.183s-3.879-4.687-4.327-.941-.343,9.852-4.451,7.455-6.911-14.656-12.136-9.7c0,0-2.508-5.229-4.469-3.955s.285,6.027.285,6.027-6.382-1.1,1.287,10.024c0,0-2.767,1.125-1.534,3.469,1.971,3.748,9.074,9.743,15.653,12.691C663.523,802.663,664.448,790.981,664.448,790.981Z",
    transform: "translate(-634.934 -765.464)",
    fill: "#fd8b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8535",
    "data-name": "Caminho 8535",
    d: "M666.6,792.781c-8.05-9.114-8.847-12.5-8.877-12.642l.528-.115c.008.033.842,3.438,8.754,12.4Z",
    transform: "translate(-651.311 -775.929)",
    fill: "#e56542"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8536",
    "data-name": "Caminho 8536",
    d: "M652.531,800.243c-4.615-4.445-9.524-12.771-9.573-12.856l.466-.273c.049.083,4.921,8.347,9.482,12.74Z",
    transform: "translate(-640.701 -781.024)",
    fill: "#e56542"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8537",
    "data-name": "Caminho 8537",
    d: "M653.932,829.121c-2.79-2.641-6.221-6.149-6.255-6.185l.387-.378c.034.035,3.458,3.536,6.24,6.17Z",
    transform: "translate(-644.092 -806.498)",
    fill: "#e56542"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8538",
    "data-name": "Caminho 8538",
    d: "M876.358,1059.435l-1.1-.33c.141-.472,3.481-11.588,4.641-13.909l1.03.516C879.812,1047.944,876.394,1059.321,876.358,1059.435Z",
    transform: "translate(-807.652 -966.506)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2175",
    "data-name": "Ret\\xE2ngulo 2175",
    width: 1.151,
    height: 11.667,
    transform: "translate(45.71 69.885) rotate(-10.534)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2176",
    "data-name": "Ret\\xE2ngulo 2176",
    width: 1.151,
    height: 10.331,
    transform: "translate(182.353 87.641) rotate(-8.97)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8539",
    "data-name": "Caminho 8539",
    d: "M937.317,1304.51l35.377-1.608-11.256-35.378-16.885-2.412Z",
    transform: "translate(-852.255 -1124.558)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8540",
    "data-name": "Caminho 8540",
    d: "M988.145,1282.081l-10.245-.854,2.887-23.509,1.143.141-2.741,22.321,9.052.754Z",
    transform: "translate(-881.421 -1119.243)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8541",
    "data-name": "Caminho 8541",
    d: "M862.411,1292.869l-.763-.862,4.322-3.828,1.577-31.66,1.15.057-1.6,32.145Z",
    transform: "translate(-797.872 -1118.382)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8542",
    "data-name": "Caminho 8542",
    d: "M1135.283,1292.8l-7.007-2.242-8.117-33.279,1.118-.272,7.964,32.651,6.393,2.046Z",
    transform: "translate(-983.662 -1118.733)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8543",
    "data-name": "Caminho 8543",
    d: "M1364.619,1860.92l8.813,8.562,23.429-21.34-8.925-8.529Z",
    transform: "translate(-1159.354 -1537.448)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8544",
    "data-name": "Caminho 8544",
    d: "M995.659,923.518q-1.349,0-2.838-.144c-14.064-1.379-12.86-20.257-12.846-20.447l1.148.083c-.012.179-1.136,17.949,11.811,19.218,13.5,1.325,17.285-6.918,20.838-17.83l1.095.356C1011.528,915.007,1007.715,923.518,995.659,923.518Z",
    transform: "translate(-882.89 -864.257)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2177",
    "data-name": "Ret\\xE2ngulo 2177",
    width: 1.151,
    height: 9.6,
    transform: "translate(148.176 86.69) rotate(-6.591)",
    fill: "#251138"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8545",
    "data-name": "Caminho 8545",
    d: "M1005.105,875.766c-8.4,0-12.237-9.818-9.979-12.077a7.954,7.954,0,0,0,1.586-2.456h.007a16.544,16.544,0,0,0,1.141-4.264l.007-.006L1013.4,843.1c-.839,8.825,2.937,15.02,4.308,19.433S1014.664,875.766,1005.105,875.766Z",
    transform: "translate(-893.344 -801.741)",
    fill: "#fd8b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8546",
    "data-name": "Caminho 8546",
    d: "M1016.375,872.856c-4.455,8.523-13.7,7.676-13.958,7.695a16.561,16.561,0,0,0,1.141-4.264l.006-.006C1003.984,876.039,1020.552,864.867,1016.375,872.856Z",
    transform: "translate(-899.042 -821.058)",
    opacity: 0.19
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8547",
    "data-name": "Caminho 8547",
    d: "M1071.838,782.431s-.668,8.054-12.38,16.352c-12.278,8.7,1.7-18.039,1.7-18.039Z",
    transform: "translate(-936.408 -756.925)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8548",
    "data-name": "Caminho 8548",
    d: "M988.353,769.538s-1.658,6.941-3.807,14.731c-3.073,11.136-3.335,20.142,8.009,20.142,19.053,0,17.784-31.616,17.784-31.616Z",
    transform: "translate(-884.893 -748.871)",
    fill: "#fd8b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8549",
    "data-name": "Caminho 8549",
    d: "M995.219,723.563s-28.57-.64-24.632-19.962,15.145,4.626,20.955,4.626c6.816,0,25.38.993,18.566,17.216C1008.341,729.658,1005.515,724.222,995.219,723.563Z",
    transform: "translate(-875.898 -696.069)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_680",
    "data-name": "Elipse 680",
    cx: 5.749,
    cy: 5.749,
    rx: 5.749,
    ry: 5.749,
    transform: "translate(117.644 38.698)",
    fill: "#fd8b66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8550",
    "data-name": "Caminho 8550",
    d: "M1009.667,814.238s-3.118,7.6-7.015,9.938-10.328-3.9-19.682-2.144c0,0-.779,10.328,2.532,15.978,0,0,9.939,1.949,15.785-4.482a90.24,90.24,0,0,0,9.938-13.446Z",
    transform: "translate(-885.008 -780.996)",
    fill: "#251138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8551",
    "data-name": "Caminho 8551",
    d: "M994.438,853.724l6.042.78s-.585,5.359-3.9,4.872S994.438,853.724,994.438,853.724Z",
    transform: "translate(-893.164 -809.374)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7138",
    "data-name": "Grupo 7138",
    transform: "translate(357.516 300.882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8552",
    "data-name": "Caminho 8552",
    d: "M1425.96,1562.569c-13.724-20.434-28.012-43.032-25.222-45.258,1.012-.807,3.93,1.334,6.145,2.959,16.3,11.956,20.259,33.381,21.337,41.149Z",
    transform: "translate(-1400.386 -1481.345)",
    fill: "#9fa3bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8553",
    "data-name": "Caminho 8553",
    d: "M1440.665,1577.234a.267.267,0,0,1-.244-.161,140.834,140.834,0,0,0-20.108-32.889.267.267,0,0,1,.413-.337,141.378,141.378,0,0,1,20.184,33.014.267.267,0,0,1-.245.373Z",
    transform: "translate(-1414.669 -1500.479)",
    fill: "#30354f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8554",
    "data-name": "Caminho 8554",
    d: "M1505.664,1562.061c13.208-20.771,26.926-43.721,24.081-45.875-1.031-.781-3.9,1.432-6.069,3.113-15.992,12.36-19.416,33.877-20.3,41.669Z",
    transform: "translate(-1474.405 -1480.546)",
    fill: "#9fa3bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8555",
    "data-name": "Caminho 8555",
    d: "M1508.9,1577.023a.268.268,0,0,1-.247-.368,141.385,141.385,0,0,1,19.351-33.509.267.267,0,0,1,.422.327,140.822,140.822,0,0,0-19.278,33.382A.269.269,0,0,1,1508.9,1577.023Z",
    transform: "translate(-1478.186 -1499.966)",
    fill: "#30354f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8556",
    "data-name": "Caminho 8556",
    d: "M1484.5,1470.862c-3.031-38.333-5.173-80.046.329-80.939,2-.324,4.329,4.828,6.1,8.737,13.028,28.762,2.012,60.966-2.472,72.367Z",
    transform: "translate(-1458.633 -1389.908)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8557",
    "data-name": "Caminho 8557",
    d: "M1500.455,1504.632a.267.267,0,0,1-.263-.309,225.124,225.124,0,0,0,.823-65.2.267.267,0,1,1,.528-.071,225.647,225.647,0,0,1-.824,65.356.267.267,0,0,1-.264.226Z",
    transform: "translate(-1472.112 -1425.06)",
    fill: "#30354f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7139",
    "data-name": "Grupo 7139",
    transform: "translate(104.228 283.612)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8558",
    "data-name": "Caminho 8558",
    d: "M530.619,1535.318c-16.438-24.474-33.551-51.542-30.21-54.208,1.211-.966,4.707,1.6,7.36,3.544,19.519,14.321,24.265,39.982,25.556,49.285Z",
    transform: "translate(-499.987 -1438.033)",
    fill: "#9fa3bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8559",
    "data-name": "Caminho 8559",
    d: "M548.21,1552.852a.32.32,0,0,1-.293-.192,168.688,168.688,0,0,0-24.085-39.394.319.319,0,0,1,.495-.4A169.333,169.333,0,0,1,548.5,1552.4a.319.319,0,0,1-.293.447Z",
    transform: "translate(-517.073 -1460.919)",
    fill: "#30354f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8560",
    "data-name": "Caminho 8560",
    d: "M626.085,1534.711c15.82-24.879,32.251-52.366,28.844-54.947-1.235-.936-4.666,1.716-7.269,3.728-19.154,14.805-23.257,40.577-24.313,49.91Z",
    transform: "translate(-588.644 -1437.077)",
    fill: "#9fa3bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8561",
    "data-name": "Caminho 8561",
    d: "M629.966,1552.632a.319.319,0,0,1-.3-.44,169.305,169.305,0,0,1,23.178-40.135.319.319,0,1,1,.5.392,168.716,168.716,0,0,0-23.091,39.983A.321.321,0,0,1,629.966,1552.632Z",
    transform: "translate(-593.172 -1460.337)",
    fill: "#30354f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8562",
    "data-name": "Caminho 8562",
    d: "M600.738,1425.478c-3.63-45.914-6.2-95.874.394-96.944,2.391-.388,5.184,5.782,7.305,10.465,15.6,34.449,2.409,73.022-2.961,86.677Z",
    transform: "translate(-569.753 -1328.516)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8563",
    "data-name": "Caminho 8563",
    d: "M619.847,1465.928a.394.394,0,0,1-.051,0,.32.32,0,0,1-.265-.365,269.606,269.606,0,0,0,.986-78.1.32.32,0,0,1,.633-.084,270.243,270.243,0,0,1-.988,78.279A.319.319,0,0,1,619.847,1465.928Z",
    transform: "translate(-585.899 -1370.621)",
    fill: "#30354f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2179",
    "data-name": "Ret\\xE2ngulo 2179",
    width: 453.399,
    height: 2.782,
    rx: 1.391,
    transform: "translate(36.371 378.694)",
    fill: "#5f6386"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_7140",
    "data-name": "Grupo 7140",
    transform: "translate(20.759 186.888)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8564",
    "data-name": "Caminho 8564",
    d: "M354.271,1098.4H259.617a9.46,9.46,0,0,1-9.46-9.46V1041.11a9.459,9.459,0,0,1,9.462-9.46h94.653a9.46,9.46,0,0,1,9.46,9.46v47.827a9.46,9.46,0,0,1-9.46,9.46Z",
    transform: "translate(-236.966 -1018.437)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8565",
    "data-name": "Caminho 8565",
    d: "M634.623,1155.688l19.119,19.12H635.764Z",
    transform: "translate(-513.279 -1107.582)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2180",
    "data-name": "Ret\\xE2ngulo 2180",
    width: 82.185,
    height: 5.504,
    rx: 2.752,
    transform: "translate(29.456 29.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2181",
    "data-name": "Ret\\xE2ngulo 2181",
    width: 53.934,
    height: 5.504,
    rx: 2.752,
    transform: "translate(29.456 43.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2182",
    "data-name": "Ret\\xE2ngulo 2182",
    width: 71.626,
    height: 5.504,
    rx: 2.752,
    transform: "translate(29.456 59.153)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_683",
    "data-name": "Elipse 683",
    cx: 14.617,
    cy: 14.617,
    rx: 14.617,
    ry: 14.617,
    fill: "#ffaa40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8566",
    "data-name": "Caminho 8566",
    d: "M241.459,1020.4a6.4,6.4,0,0,1,.067-.943,3.22,3.22,0,0,1,.257-.868,2.729,2.729,0,0,1,.548-.782,3.619,3.619,0,0,1,.939-.664l.771-.4a8.021,8.021,0,0,0,.939-.568,3.822,3.822,0,0,0,.794-.739,1.452,1.452,0,0,0,.335-.932,1.3,1.3,0,0,0-.536-1.1,2.016,2.016,0,0,0-1.23-.4,1.855,1.855,0,0,0-.793.161,3.007,3.007,0,0,0-.626.385,2.585,2.585,0,0,0-.48.5q-.2.279-.358.493l-2.3-1.542a4.332,4.332,0,0,1,1.845-2.036,5.6,5.6,0,0,1,2.85-.728,6.328,6.328,0,0,1,1.7.236,4.421,4.421,0,0,1,1.519.75,3.94,3.94,0,0,1,1.1,1.328,4.221,4.221,0,0,1,.425,1.972,3.739,3.739,0,0,1-.525,2.046,4.638,4.638,0,0,1-1.554,1.446,9.549,9.549,0,0,1-.95.534,9.025,9.025,0,0,0-.883.493,2.5,2.5,0,0,0-.647.579,1.228,1.228,0,0,0-.246.771Zm.067,5.249v-3.214h2.929v3.214Z",
    transform: "translate(-229.51 -1003.051)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8567",
    "data-name": "Caminho 8567",
    d: "M1331.364,640.56h101.895a10.183,10.183,0,0,0,10.183-10.183V578.889a10.183,10.183,0,0,0-10.183-10.183H1331.364a10.183,10.183,0,0,0-10.184,10.183v51.487a10.184,10.184,0,0,0,10.184,10.184Z",
    transform: "translate(-985.946 -498.833)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8568",
    "data-name": "Caminho 8568",
    d: "M1289.343,702.232l-20.582,20.582h19.354Z",
    transform: "translate(-948.271 -594.798)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2183",
    "data-name": "Ret\\xE2ngulo 2183",
    width: 88.472,
    height: 5.925,
    rx: 2.963,
    transform: "translate(439.988 93.084) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2184",
    "data-name": "Ret\\xE2ngulo 2184",
    width: 58.06,
    height: 5.925,
    rx: 2.963,
    transform: "translate(439.988 108.322) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_2185",
    "data-name": "Ret\\xE2ngulo 2185",
    width: 77.106,
    height: 5.925,
    rx: 2.963,
    transform: "translate(439.988 125.251) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_684",
    "data-name": "Elipse 684",
    cx: 15.735,
    cy: 15.735,
    rx: 15.735,
    ry: 15.735,
    transform: "translate(440.228 55.648)",
    fill: "#ffaa40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8569",
    "data-name": "Caminho 8569",
    d: "M1733.677,556.594a6.968,6.968,0,0,1,.072-1.015,3.5,3.5,0,0,1,.277-.934,2.937,2.937,0,0,1,.591-.842,3.938,3.938,0,0,1,1.011-.715q.312-.162.831-.427a8.622,8.622,0,0,0,1.01-.611,4.141,4.141,0,0,0,.855-.8,1.563,1.563,0,0,0,.361-1,1.392,1.392,0,0,0-.577-1.188,2.171,2.171,0,0,0-1.322-.427,2.017,2.017,0,0,0-.854.173,3.229,3.229,0,0,0-.673.416,2.771,2.771,0,0,0-.518.542q-.217.3-.385.53l-2.48-1.66a4.667,4.667,0,0,1,1.986-2.191,6.03,6.03,0,0,1,3.069-.784,6.814,6.814,0,0,1,1.828.253,4.741,4.741,0,0,1,1.637.807,4.245,4.245,0,0,1,1.179,1.429,4.539,4.539,0,0,1,.457,2.122,4.03,4.03,0,0,1-.565,2.2,4.981,4.981,0,0,1-1.673,1.557,10.4,10.4,0,0,1-1.023.576,9.6,9.6,0,0,0-.95.531,2.667,2.667,0,0,0-.7.623,1.329,1.329,0,0,0-.265.83Zm.072,5.651v-3.46h3.152v3.46Z",
    transform: "translate(-1281.108 -482.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_685",
    "data-name": "Elipse 685",
    cx: 29.167,
    cy: 29.167,
    rx: 29.167,
    ry: 29.167,
    transform: "translate(153.546 56.799)",
    fill: "#ffaa40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8570",
    "data-name": "Caminho 8570",
    d: "M748.072,593.512a12.851,12.851,0,0,1,.134-1.881,6.471,6.471,0,0,1,.513-1.732,5.441,5.441,0,0,1,1.093-1.56,7.279,7.279,0,0,1,1.874-1.326l1.539-.791a15.866,15.866,0,0,0,1.874-1.133,7.655,7.655,0,0,0,1.583-1.475,2.9,2.9,0,0,0,.67-1.86,2.582,2.582,0,0,0-1.071-2.2,4.023,4.023,0,0,0-2.454-.791,3.726,3.726,0,0,0-1.583.321,5.975,5.975,0,0,0-1.249.77,5.186,5.186,0,0,0-.959,1q-.4.556-.714.985l-4.6-3.078a8.645,8.645,0,0,1,3.681-4.062,11.183,11.183,0,0,1,5.688-1.454,12.651,12.651,0,0,1,3.39.47,8.808,8.808,0,0,1,3.034,1.5,7.869,7.869,0,0,1,2.186,2.651,8.416,8.416,0,0,1,.848,3.933,7.457,7.457,0,0,1-1.049,4.083,9.245,9.245,0,0,1-3.1,2.885,19.451,19.451,0,0,1-1.9,1.069,17.871,17.871,0,0,0-1.762.985,4.971,4.971,0,0,0-1.294,1.153,2.458,2.458,0,0,0-.491,1.539Zm.134,10.474v-6.414h5.844v6.414Z",
    transform: "translate(-571.651 -502.097)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_686",
    "data-name": "Elipse 686",
    cx: 13.816,
    cy: 13.816,
    rx: 13.816,
    ry: 13.816,
    transform: "translate(366.543 255.98)",
    fill: "#ffaa40"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_687",
    "data-name": "Elipse 687",
    cx: 13.816,
    cy: 13.816,
    rx: 13.816,
    ry: 13.816,
    transform: "translate(259.852 1.535)",
    fill: "none",
    stroke: "#494e6d",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_688",
    "data-name": "Elipse 688",
    cx: 10.17,
    cy: 10.17,
    rx: 10.17,
    ry: 10.17,
    transform: "translate(171.008 285.339)",
    fill: "none",
    stroke: "#494e6d",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_689",
    "data-name": "Elipse 689",
    cx: 10.362,
    cy: 10.362,
    rx: 10.362,
    ry: 10.362,
    transform: "translate(102.12 117.052)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_690",
    "data-name": "Elipse 690",
    cx: 8.635,
    cy: 8.635,
    rx: 8.635,
    ry: 8.635,
    transform: "translate(412.98 181.911)",
    fill: "#494e6d"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Elipse_691",
    "data-name": "Elipse 691",
    cx: 10.362,
    cy: 10.362,
    rx: 10.362,
    ry: 10.362,
    transform: "translate(273.669 78.674)",
    fill: "#ffaa40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8571",
    "data-name": "Caminho 8571",
    d: "M573.487,1589.151c-32.084-4.556-38.572-15.048-69.08-15.735-41.4-.932-42.738,18.088-81.361,17.27-43.64-.924-61.691-25.114-86.734-9.978-10.276,6.211-23.014,20.686-22.643,21.108a9.434,9.434,0,0,0,2.3-1.535h407.19c-12.137-8.125-32.238-19.19-58.334-21.875C627.54,1574.569,615.011,1595.048,573.487,1589.151Z",
    transform: "translate(-261.847 -1220.888)",
    fill: "#30354f"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupUserLimit);
export default __webpack_public_path__ + "static/media/Group User Limit.e21a5efd.svg";
export { ForwardRef as ReactComponent };